/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListPreconfiguredSkillsRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListPreconfiguredSkillsRequest$inboundSchema: z.ZodType<
  ListPreconfiguredSkillsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListPreconfiguredSkillsRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListPreconfiguredSkillsRequest$outboundSchema: z.ZodType<
  ListPreconfiguredSkillsRequest$Outbound,
  z.ZodTypeDef,
  ListPreconfiguredSkillsRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listPreconfiguredSkillsRequestToJSON(
  listPreconfiguredSkillsRequest: ListPreconfiguredSkillsRequest,
): string {
  return JSON.stringify(
    ListPreconfiguredSkillsRequest$outboundSchema.parse(
      listPreconfiguredSkillsRequest,
    ),
  );
}
export function listPreconfiguredSkillsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListPreconfiguredSkillsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListPreconfiguredSkillsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListPreconfiguredSkillsRequest' from JSON`,
  );
}
